import { formatISO } from "date-fns";
import { useDispatch } from "react-redux";
import { casesActions } from "configs";
import { useCurrentCase, useParams } from "duck";
import { useUpdateCalculationAgreementMutation } from "requests";
import { FormValues } from "./types";

export const useUpdateAgreement = (agreementId: number) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);
  const [update] = useUpdateCalculationAgreementMutation({
    ignoreResults: true
  });

  return (values: FormValues) => {
    dispatch(
      casesActions.updateCalculationAgreement({
        _id: id,
        data: {
          signedAt: formatISO(new Date()),
          file: values.signature
        }
      })
    );

    if (shouldSync) {
      return update({
        variables: {
          input: {
            _id: agreementId,
            // TODO create editable tag for date
            signedAt: formatISO(new Date()),
            file: values.signature
          }
        }
      });
    }
  };
};
